import * as React from "react"
import { Route, Switch } from "react-router-dom"
import Landing from "./main"


const Layout = () => {
  return (
      <Switch>
        <Route exact path="/" component={Landing} />
      </Switch>
  )
}

export default Layout
